<div class="container py-3">
  <h2 class="mb-3">{{ pageTitle }}</h2>

    <!-- Top row: User List (left) and User Details (right) -->
    <div class="col-12">
      <div class="row g-3 align-items-start">
        <div class="col-12 col-md-7">
          <div class="subsection user-list-subsection">
            <div class="d-flex justify-content-between align-items-center mb-2 subheader">
              <h4 class="m-0 subsection-title">User List</h4>
            </div>

            <!-- Control row: search + actions -->
            <div class="d-flex align-items-center mb-2 gap-2">
              <input class="form-control form-control-sm w-50" [(ngModel)]="searchKeywords" placeholder="Search keywords" (keyup.enter)="getFilteredUsers(searchKeywords)"/>
              <button class="btn btn-sm btn-outline-primary" (click)="getFilteredUsers(searchKeywords)">Search</button>
              <button class="btn btn-sm btn-danger" [disabled]="!selectedUser" (click)="triggerDeleteSelected()">Delete</button>
            </div>

            <!-- Table styled like License list -->
            <div class="table-responsive border rounded">
              <table class="table table-sm table-hover align-middle mb-0">
                <thead class="table-light">
                  <tr>
                    <th>Profile Name</th>
                    <th>Email</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let user of pagedUsers" (click)="selectOne(user)" [class.table-active]="isSelectedInList(user)" style="cursor:pointer;">
                    <td>{{ user.userName }}</td>
                    <td>{{ user.email }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Pagination navigation -->
            <div class="d-flex justify-content-between align-items-center mt-3 user-list-pagination">
              <div>
                <strong>Users:</strong>
                {{ totalUsers === 0 ? 0 : (currentPage-1)*pageSize + 1 }} - {{ Math.min(currentPage*pageSize, totalUsers) }} / {{ totalUsers }}
              </div>
              <div class="btn-toolbar" role="toolbar" aria-label="pagination">
                <div class="btn-group me-2" role="group" aria-label="first-prev">
                  <button type="button" class="btn btn-sm btn-outline-secondary" (click)="goFirst()" [disabled]="currentPage === 1">« First</button>
                  <button type="button" class="btn btn-sm btn-outline-secondary" (click)="goPrev()" [disabled]="currentPage === 1">‹ Prev</button>
                </div>
                <div class="btn-group me-2" role="group" aria-label="pages">
                  <button *ngFor="let p of pageWindow" type="button"
                          class="btn btn-sm"
                          [ngClass]="{'btn-primary': p === currentPage, 'btn-outline-secondary': p !== currentPage}"
                          (click)="goToPage(p)">{{ p }}</button>
                </div>
                <div class="btn-group" role="group" aria-label="next-last">
                  <button type="button" class="btn btn-sm btn-outline-secondary" (click)="goNext()" [disabled]="currentPage === totalPages">Next ›</button>
                  <button type="button" class="btn btn-sm btn-outline-secondary" (click)="goLast()" [disabled]="currentPage === totalPages">Last »</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Right column: User Roles (top) + User Details (below) -->
        <div class="col-12 col-md-5">
          <!-- User Roles subsection -->
          <div class="subsection" *ngIf="selectedUser">
            <div class="d-flex justify-content-between align-items-center mb-2 subheader">
              <h4 class="m-0 subsection-title">User Roles</h4>
            </div>
            <div>
              <div *ngIf="userRoles && userRoles.length > 0; else emptyRoles">
                <table class="table table-sm">
                  <thead>
                    <tr><th>Role</th><th style="width:160px; text-align:right;">Action</th></tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let r of userRoles">
                      <td>{{ r.name }}</td>
                      <td style="text-align:right;">
                        <button *ngIf="canRemoveRole(r)" class="btn btn-sm btn-outline-danger" style="width: 160px;" (click)="onClickRemoveRole(r)">Remove this Role</button>
                        <span *ngIf="!canRemoveRole(r)" class="text-muted small">Read-only</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <ng-template #emptyRoles>
                <div class="text-muted">No roles assigned.</div>
              </ng-template>

              <div class="my-3"></div>

              <div class="d-flex gap-2 align-items-center">
                <select class="form-select form-select-sm" style="width: 48%; max-width: 220px;" [(ngModel)]="selectedNewRole">
                  <option *ngFor="let opt of addRoleOptions" [value]="opt">{{ opt }}</option>
                </select>
                <button class="btn btn-sm btn-primary ms-auto" style="width: 160px;" (click)="onClickAddRole()">Add this Role</button>
              </div>
            </div>
          </div>

          <div class="my-3" *ngIf="selectedUser" style="border-top:6px double #222;"></div>

          <!-- User Details subsection (moved below Roles) -->
          <div *ngIf="selectedUser">
            <form (ngSubmit)="onSubmit()">
              <div class="subsection">
                <div class="d-flex justify-content-between align-items-center mb-2 subheader">
                  <h4 class="m-0 subsection-title">User Details</h4>
                  <div class="ms-auto d-flex align-items-center gap-3">
                    <div class="form-check form-switch m-0">
                      <input class="form-check-input" type="checkbox" id="editSwitchUser" [checked]="canEditUser" (change)="canEditUser = $any($event.target).checked">
                      <label class="form-check-label small ms-2" for="editSwitchUser">Editing</label>
                    </div>
                    <button type="submit" class="btn btn-sm btn-primary" *ngIf="canEditUser">Update User and its MP(s)</button>
                  </div>
                </div>

                <div class="row g-2 form-edit">
                  <hr>
                  <div class="row row-cols-1 row-cols-md-1 g-3 mb-3">
                    <div class="col">
                      <label class="form-label d-flex align-items-center">User ID</label>
                      <input type="text" class="form-control" [value]="selectedUser.userId" disabled>
                    </div>
                    <div class="col">
                      <label class="form-label d-flex align-items-center">Email</label>
                      <input type="text" class="form-control" [value]="selectedUser.email" disabled>
                    </div>
                    <div class="col">
                      <label class="form-label d-flex align-items-center">Authentication Source</label>
                      <input type="text" class="form-control" [value]="selectedUser.authType" disabled>
                    </div>
                    <div class="col">
                      <label class="form-label d-flex align-items-center">Account Creation Date</label>
                      <input type="text" class="form-control" [value]="selectedUser.creationDate" disabled>
                    </div>
                    <div class="col">
                      <label class="form-label d-flex align-items-center">Last Login Date</label>
                      <input type="text" class="form-control" [value]="selectedUser.lastLoginDate" disabled>
                    </div>
                  </div>

                  <div class="row row-cols-1 row-cols-md-1 g-3 mb-3">
                    <div class="col">
                      <label for="userName" class="form-label d-flex align-items-center">Profile Name
                        <span class="material-icons ms-1 text-muted" matTooltip="{{ userService.helpData.userName.description }}">info</span>
                      </label>
                      <input type="text" class="form-control" id="userName" [(ngModel)]="selectedUser.userName" name="userName" [disabled]="!canEditUser" [style.color]="canEditUser ? 'blue' : 'inherit'">
                    </div>
                    <div class="col">
                      <label for="uUserName" class="form-label d-flex align-items-center">Upload User Name
                        <span class="material-icons ms-1 text-muted" matTooltip="{{ userService.helpData.uUserName.description }}">info</span>
                      </label>
                      <input type="text" class="form-control" id="uUserName" [(ngModel)]="selectedUser.uUserName" name="uUserName" [disabled]="!canEditUser" [style.color]="canEditUser ? 'blue' : 'inherit'">
                    </div>
                    <div class="col">
                      <label for="uPassword" class="form-label d-flex align-items-center">Upload Password
                        <span class="material-icons ms-1 text-muted" matTooltip="{{ userService.helpData.uPassword.description }}">info</span>
                      </label>
                      <input type="text" class="form-control" id="uPassword" [(ngModel)]="selectedUser.uPassword" name="uPassword" [disabled]="!canEditUser" [style.color]="canEditUser ? 'blue' : 'inherit'">
                    </div>
                    <div class="col">
                      <label for="dUserName" class="form-label d-flex align-items-center">Download User Name
                        <span class="material-icons ms-1 text-muted" matTooltip="{{ userService.helpData.dUserName.description }}">info</span>
                      </label>
                      <input type="text" class="form-control" id="dUserName" [(ngModel)]="selectedUser.dUserName" name="dUserName" [disabled]="!canEditUser" [style.color]="canEditUser ? 'blue' : 'inherit'">
                    </div>
                  </div>

                  <div class="row row-cols-1 row-cols-md-1 g-3 mb-3">
                    <div class="col">
                      <label for="dPassword" class="form-label d-flex align-items-center">Download Password
                        <span class="material-icons ms-1 text-muted" matTooltip="{{ userService.helpData.dPassword.description }}">info</span>
                      </label>
                      <input type="text" class="form-control" id="dPassword" [(ngModel)]="selectedUser.dPassword" name="dPassword" [disabled]="!canEditUser" [style.color]="canEditUser ? 'blue' : 'inherit'">
                    </div>
                    <div class="col">
                      <label for="maxMpNumber" class="form-label d-flex align-items-center">Maximum Number of Mountpoint Allowed
                        <span class="material-icons ms-1 text-muted" matTooltip="{{ userService.helpData.maxMpNumber.description }}">info</span>
                      </label>
                      <input type="number" class="form-control" id="maxMpNumber" [(ngModel)]="selectedUser.maxMpNumber" name="maxMpNumber" [disabled]="!canEditUser" [style.color]="canEditUser ? 'blue' : 'inherit'">
                    </div>
                    <div class="col">
                      <label for="maxClientNumber" class="form-label d-flex align-items-center">Maximum Number of Concurrent Client Allowed
                        <span class="material-icons ms-1 text-muted" matTooltip="{{ userService.helpData.maxClientNumber.description }}">info</span>
                      </label>
                      <input type="number" class="form-control" id="maxClientNumber" [(ngModel)]="selectedUser.maxClientNumber" name="maxClientNumber" [disabled]="!canEditUser" [style.color]="canEditUser ? 'blue' : 'inherit'">
                    </div>
                    <div class="col">
                      <label class="form-label d-flex align-items-center">Account enabled?
                        <span class="material-icons ms-1 text-muted" matTooltip="{{ userService.helpData.active.description }}">info</span>
                      </label>
                      <div class="form-check mt-1">
                        <input class="form-check-input" type="checkbox" id="active" [(ngModel)]="selectedUser.active" name="active" [disabled]="!canEditUser">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>

            <!-- Mountpoints subsection -->
            <div class="subsection mt-2">
              <div class="d-flex justify-content-between align-items-center mb-2 subheader">
              <h4 class="m-0 subsection-title">Mountpoint(s) of this User</h4>
              </div>
            <div class="d-flex align-items-center mb-2 gap-2">
              <button class="btn btn-sm btn-primary" [disabled]="!canEditUser || !mpList?.selectedMountPoint" (click)="mpList.openEditSelected()">Edit MountPoint</button>
              <button class="btn btn-sm btn-danger" [disabled]="!canEditUser || !mpList?.selectedMountPoint" (click)="mpList.triggerDeleteSelected()">Delete MountPoint</button>
            </div>
              <app-mountpoint-list #mpList [user]="selectedUser"></app-mountpoint-list>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>